import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function PackageFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/packages/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      showActionBar
      selectedKeys={params.package_id?.split(",") || []}
      onSelectionChange={(keys) => setParam("package_id", Array.from(keys))}
      label={t("Package")}
      items={data ?? []}
      selectionMode="multiple"
      testID="package-filter"
    />
  );
}
